module.exports = __webpack_public_path__ + "img/vi.614d5679.png";